import { render, staticRenderFns } from "./OrderOverviewPage.vue?vue&type=template&id=c37e53ea&scoped=true"
import script from "./OrderOverviewPage.vue?vue&type=script&lang=js"
export * from "./OrderOverviewPage.vue?vue&type=script&lang=js"
import style0 from "./OrderOverviewPage.vue?vue&type=style&index=0&id=c37e53ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37e53ea",
  null
  
)

export default component.exports